import React, {Component} from 'react';
import Stage from './stage/stage';
import BoothIcon from './booth-icon';

/** @class Hall
 * A component for rendering a hall
 * of a virtual expo.
 */
export default class Hall extends Component {

  /** @function
   * Renders the hall component.
   */
  render() {
    var boothIcons = this.props.booths.map((booth) => (
      <BoothIcon {...booth}
        key={booth.id}
        />
    ));
    return (
      <Stage {...this.props.stage} icons={boothIcons} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/booth-preview/hall.js